/***
 * Created on 2023/12/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";


function ObserverChangePasswordDialog({...props}) {
    const { t } = useTranslation();

    const onSubmit = () => {
        location.href = '/account/security#change_passwd';
    }

    return (
        <ModalDialog {...props} title={t('@Consider changing your password@')} submitText={t('@Safety Comes First@')} hideCancel={true} submitAction={onSubmit}>
            <div className="dialog-content">
                <p className="!mb-16">
                    {t('@Your security on QNAP Cloud Services is our top priority. We have detected suspicious activity on your account. For you account security, please consider changing your password today.@')}
                </p>
            </div>
        </ModalDialog>
    );
}

export default ObserverChangePasswordDialog;